import React from 'react';
// import Feature from '../../components/feature/Feature';
import { Feature } from '../../components';
import './features.css';

// We create this 'featuresData' [array] to hold our features data, which we loop through below in the "Features" component.
const featuresData = [
  {
    title: 'Language Models',
    text: 'We introduce Codex, a GPT language model fine-tuned on publicly available code from GitHub, and study its Python code-writing capabilities.',
  },
  {
    title: 'Recursive Summarization',
    text: 'A major challenge for scaling machine learning is training models to perform tasks that are very difficult or time-consuming for humans to evaluate. We present progress on this problem on the task of abstractive summarization of entire fiction novels.',
  },
  {
    title: 'Multimodal Neurons in Artificial Neural Networks',
    text: 'We report the existence of similar multimodal neurons in artificial neural networks. This includes neurons selecting for prominent public figures or fictional characters, such as Lady Gaga or Spiderman. Like the biological multimodal neurons, these artificial neurons respond to the same subject in photographs, drawings, and images of their name.',
  },
  {
    title: 'Generative Pretraining from Pixels',
    text: 'Inspired by progress in unsupervised representation learning for natural language, we examine whether similar models can learn useful representations for images.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">Step into future, today. Let GPT-3 be your guide.</h1>
      <p>Request Early Access to Get Started</p>
    </div>
    <div className="gpt3__features-container">
      {/* loops over our features and renders different text for each item */}
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;